export default __webpack_public_path__ + "static/media/paywayLogoDark.efd74e8f.png";